import ApplicationSerializer from 'lumen/serializers/application';

export default class CarecommendationReasonSerializer extends ApplicationSerializer {
  // Use "carecommendation" as the primary key so the we can serialize data to the store
  primaryKey = 'carecommendation';
}
